import { gql } from '@apollo/client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useEffect, useState } from 'react';
import { To, useLocation, useNavigate } from 'react-router-dom';
import { pathURL } from 'src/common/constants';
import { MenuType } from 'src/common/interfaces';
import { InfoMessage, InfoWord } from 'src/enum/messsage-enum';
import { deleteLogMaintenance, insertLogMaintenance } from 'src/graphql/mutations';
import { getLogMaintenance } from 'src/graphql/queries';
import { useAppLazyQuery, useAppMutation } from 'src/libs/hooks';
import utility from 'src/libs/utility';
import MainLayout from '../main-layout';

const AdminConsole = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dataListMenuLeft = [
    {
      name: 'ユーザ',
      link: pathURL.MST_USER.pathName,
      id: 1,
    },
    {
      name: '商流',
      link: pathURL.MST_SALE_FLOW.pathName,
      id: 2,
    },
    {
      name: '品名',
      link: pathURL.MST_HINMEI.pathName,
      id: 3,
    },
    {
      name: '仕切率',
      link: pathURL.MST_NET_RATE.pathName,
      id: 4,
    },
    {
      name: '契約期間',
      link: pathURL.MST_CONTRACT_PERIOD.pathName,
      id: 5,
    },
  ];
  const dataListMenuRight = [
    {
      name: '拠点',
      link: pathURL.MST_OFFICE.pathName,
      id: 6,
    },
    {
      name: '製品',
      link: pathURL.MST_PRODUCT.pathName,
      id: 7,
    },
    {
      name: '品名情報紐づけ',
      link: pathURL.MST_RELATION.pathName,
      id: 8,
    },
    {
      name: '備考',
      link: pathURL.MST_REMARKS.pathName,
      id: 9,
    },
    {
      name: '制御ルール',
      link: pathURL.MST_CONTROL_RULE.pathName,
      id: 10,
    },
  ];

  // メンテナンスモードに移行する際の設定値
  // 1がメンテナンスモード有効
  const maintanceStatus = 1;
  const { confirmAlert } = utility;
  const [isMaintenancing, setIsMaintenancing] = useState<boolean>(false);
  const { user } = useAuthenticator((context) => [context.user]);

  const [logMaintenance] = useAppMutation({
    query: gql(insertLogMaintenance),
    onCompleted: () => setIsMaintenancing(true),
  });

  const [logDeleteMaintenance] = useAppMutation({
    query: gql(deleteLogMaintenance),
    onCompleted: () => setIsMaintenancing(false),
  });

  const [searchLogMaintenance, { data: logMData }] = useAppLazyQuery({ query: gql(getLogMaintenance) });

  const directScreen = (item: MenuType) => {
    navigate(item.link as To, { state: { from: location } });
  };

  const renderMenuItem = (item: MenuType) => {
    return (
      <button
        key={item?.id}
        className="border-black border-[1px] p-[10px] m-[25px] text-center h-[50px] w-[200px] flex justify-center items-center"
        onClick={() => directScreen(item)}
      >
        {item?.name}
      </button>
    );
  };

  const listMenuComponent = () => {
    return (
      <div className="flex row">
        <div>{dataListMenuLeft.map((item: MenuType) => renderMenuItem(item))}</div>
        <div>{dataListMenuRight.map((item: MenuType) => renderMenuItem(item))}</div>
      </div>
    );
  };

  const stopMaintance = () => {
    logDeleteMaintenance({
      variables: {
        input: {
          lm_status_kb: maintanceStatus,
        },
      },
    });
  };

  const startMaintance = () => {
    logMaintenance({
      variables: {
        input: {
          lm_start_time: new Date(),
          lm_start_user_nm: user.username,
          lm_status_kb: maintanceStatus,
        },
      },
    });
  };

  const onConfirmMaintance = () => {
    if (isMaintenancing) {
      confirmAlert(InfoMessage.CONFIRM_STOP_MAINTAINCE, '', InfoWord.WARNING, InfoWord.YES, InfoWord.NO, stopMaintance);
    } else {
      confirmAlert(
        InfoMessage.CONFIRM_START_MAINTAINCE,
        '',
        InfoWord.WARNING,
        InfoWord.YES,
        InfoWord.NO,
        startMaintance
      );
    }
  };

  useEffect(() => {
    if (!logMData) return;
    setIsMaintenancing(logMData.getLogMaintenance?.length > 0);
  }, [logMData]);

  useEffect(() => {
    searchLogMaintenance();
  }, []);

  return (
    <MainLayout>
      <div className="justify-center items-center">
        <div className="flex flex-col justify-center items-center">
          <div className="flex w-3/5">
            <button
              onClick={onConfirmMaintance}
              className={`${
                isMaintenancing ? 'bg-[#ed7d31]' : ''
              } border-black border-[1px] p-[10px] m-[25px] text-center h-[50px] flex justify-center items-center`}
            >
              <b>メンテナンス</b>
            </button>
          </div>
          <div className="mb-[50px] flex justify-center items-center">
            <b>管理メニュー</b>
          </div>
          <div className="flex justify-center items-center">{listMenuComponent()}</div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AdminConsole;
